module.exports = __webpack_public_path__ + "static/media/DF_Logo.637c437d.png";